import { useTranslation } from 'react-i18next';

import { EmailAction } from '@/shared/types/action';

const Email = ({ action }: { action: EmailAction }) => {
  const { t } = useTranslation();
  const subject = action.subject ?? '';

  return (
    <>
      <span className="text-sm leading-5 font-semibold text-muted-foreground">
        {t('actions.email.subject')}
      </span>
      <span className="text-sm leading-5 font-normal text-muted-foreground">{subject}</span>
    </>
  );
};

export default Email;
